import * as yup from 'yup';

let productTypeValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
});

export {
  productTypeValidationForm
}